import { render, staticRenderFns } from "./RdbDatastoreCreateDialog.vue?vue&type=template&id=b392c5f0&"
import script from "./RdbDatastoreCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./RdbDatastoreCreateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports